import React from 'react';
import { useIntl } from 'react-intl';
import {
  Box,
  IconButton,
  Tooltip,
  Typography,
  Button,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AddIcon from '@mui/icons-material/Add';
import { Navigate } from 'react-big-calendar';
import capitalize from '../../../../Helpers/StringsFormatting/capitalize';

const CustomizedToolbar = function CustomizedToolbar({
  onNavigate,
  label,
  onView,
  view,
  handleOpenAddDialog,
}) {
  const intl = useIntl();

  const handleChangeView = (_e, newView) => {
    if (newView) onView(newView);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1.5,
        pb: 1.5,
      }}
    >
      {/* Left cluster: today, navigation and current period */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={() => onNavigate(Navigate.TODAY)}
          sx={{ borderRadius: 5, textTransform: 'none', px: 2 }}
        >
          {intl.messages.TODAY}
        </Button>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Tooltip title={intl.messages.PREVIOUS} placement="bottom">
            <IconButton
              aria-label="previous-period"
              size="small"
              onClick={() => onNavigate(Navigate.PREVIOUS)}
            >
              <ChevronLeftIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={intl.messages.NEXT} placement="bottom">
            <IconButton
              aria-label="next-period"
              size="small"
              onClick={() => onNavigate(Navigate.NEXT)}
            >
              <ChevronRightIcon />
            </IconButton>
          </Tooltip>
        </Box>
        {label && (
          <Typography
            variant="h6"
            noWrap
            sx={{ fontWeight: 500, color: 'text.primary', ml: 0.5 }}
          >
            {capitalize(label)}
          </Typography>
        )}
      </Box>

      {/* Right cluster: view switcher and create action */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <ToggleButtonGroup
          color="primary"
          value={view}
          exclusive
          size="small"
          onChange={handleChangeView}
          aria-label="view-selection"
          sx={{
            '& .MuiToggleButton-root': {
              textTransform: 'none',
              px: 2,
              fontWeight: 500,
            },
          }}
        >
          <ToggleButton value="day">{intl.messages.DAY}</ToggleButton>
          <ToggleButton value="work_week">{intl.messages.WEEK}</ToggleButton>
          <ToggleButton value="month">{intl.messages.MONTH}</ToggleButton>
        </ToggleButtonGroup>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleOpenAddDialog}
          sx={{ borderRadius: 5, textTransform: 'none', boxShadow: 'none' }}
        >
          {intl.messages.NEW_EVENT}
        </Button>
      </Box>
    </Box>
  );
};

export default CustomizedToolbar;
